import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ClockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-navy-900 text-white pt-20 pb-24 px-4 overflow-hidden" data-id="element-49">
      {/* Background accents */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-50">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-electric-600/20 blur-[120px]" data-id="element-51"></div>
        <div className="absolute bottom-[10%] -left-[10%] w-[40%] h-[40%] rounded-full bg-brandOrange-500/10 blur-[100px]" data-id="element-52"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-53">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-54">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="flex-1 text-center lg:text-left" data-id="element-55">
            <div className="inline-flex items-center gap-2 bg-electric-600/20 text-electric-400 px-4 py-2 rounded-full font-bold text-sm mb-6 border border-electric-600/30" data-id="element-56">
              <ZapIcon className="w-4 h-4" data-id="element-57" />
              <span data-id="element-58">SISTEMA PROBADO PARA EMPRENDEDORES</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 text-white" data-id="element-59">
              SHOPIFY EXPRESS <span className="text-brandOrange-500" data-id="element-60">48H</span>
            </h1>

            <h2 className="text-2xl md:text-3xl font-medium text-gray-300 mb-8 leading-snug normal-case font-body" data-id="element-61">
              El Sistema "Anti-Perfección" para Lanzar tu Tienda este Fin de
              Semana
            </h2>

            <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-62">
              Deja de estudiar e-commerce y empieza a vender: La hoja de ruta
              exacta para pasar de "cero" a una tienda funcional y cobrando en
              menos de 48 horas.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start" data-id="element-63">
              <CTAButton href="#price-block" data-id="element-64" />
            </div>

            <div className="mt-6 flex items-center justify-center lg:justify-start gap-6 text-sm text-gray-400 font-medium" data-id="element-65">
              <div className="flex items-center gap-2" data-id="element-66">
                <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-67" />
                <span data-id="element-68">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-69">
                <ClockIcon className="w-5 h-5 text-brandOrange-500" data-id="element-70" />
                <span data-id="element-71">Oferta Limitada</span>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex-1 w-full max-w-md lg:max-w-full relative" data-id="element-72">
            <div className="relative rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(37,99,235,0.2)] border border-white/10" data-id="element-73">
              <img src="https://cdn.magicpatterns.com/uploads/gexgMtC8cjiT7Wc4DNfNxj/48h_shopify_express.png" alt="Shopify Express 48H Guía" className="w-full h-auto object-cover" data-id="element-74" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-900/80 to-transparent flex items-end p-6" data-id="element-75">
                <div className="bg-brandOrange-500 text-white font-bold px-4 py-2 rounded-lg transform -rotate-2 shadow-lg text-xl" data-id="element-76">
                  Solo $6.39 USD
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}